var _defs, _g, _g2, _rect, _g3, _g4, _path, _g5, _g6, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _g7, _g8, _path2, _g9, _g0, _path3, _g1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeywordsNoContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 671.18 356.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #809eb5;\n      }\n\n      .cls-2 {\n        fill: #fabc2f;\n      }\n\n      .cls-3 {\n        fill: #d1dadf;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        opacity: .3;\n      }\n\n      .cls-4, .cls-7, .cls-8 {\n        fill: #c6c6c6;\n      }\n\n      .cls-9 {\n        fill: #e52421;\n      }\n\n      .cls-10, .cls-5, .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-12 {\n        fill: #82a2bb;\n      }\n\n      .cls-13 {\n        fill: #00466e;\n      }\n\n      .cls-14 {\n        fill: #2f6e76;\n      }\n\n      .cls-15 {\n        fill: #7692a7;\n      }\n\n      .cls-16 {\n        fill: #7b98ae;\n      }\n\n      .cls-17 {\n        fill: #738ea2;\n      }\n\n      .cls-18 {\n        fill: #3762ab;\n      }\n\n      .cls-19 {\n        fill: #3c8a93;\n      }\n\n      .cls-20 {\n        fill: #718c9f;\n      }\n\n      .cls-21 {\n        fill: #e3f3fa;\n      }\n\n      .cls-21, .cls-22 {\n        opacity: .7;\n      }\n\n      .cls-23 {\n        fill: #6f8a9d;\n      }\n\n      .cls-24 {\n        fill: #7b99af;\n      }\n\n      .cls-25 {\n        fill: #323232;\n      }\n\n      .cls-26 {\n        fill: #7a7b7b;\n      }\n\n      .cls-27 {\n        fill: #2a2a3b;\n      }\n\n      .cls-28 {\n        fill: #7591a6;\n      }\n\n      .cls-29 {\n        fill: #81a0b7;\n      }\n\n      .cls-30 {\n        fill: #7894ab;\n      }\n\n      .cls-31 {\n        fill: #708b9d;\n      }\n\n      .cls-32 {\n        fill: #6b8798;\n      }\n\n      .cls-33 {\n        fill: #83a2b9;\n      }\n\n      .cls-34 {\n        fill: #025788;\n      }\n\n      .cls-34, .cls-35 {\n        opacity: .1;\n      }\n\n      .cls-36 {\n        fill: #03974c;\n      }\n\n      .cls-37 {\n        fill: #7f9db4;\n      }\n\n      .cls-38 {\n        fill: #6c8698;\n      }\n\n      .cls-39 {\n        fill: #08505e;\n      }\n\n      .cls-40 {\n        fill: #7490a4;\n      }\n\n      .cls-41 {\n        fill: #f8c0ae;\n      }\n\n      .cls-42 {\n        fill: #718da1;\n      }\n\n      .cls-43 {\n        fill: #32a853;\n      }\n\n      .cls-44 {\n        fill: #386ab2;\n      }\n\n      .cls-45 {\n        fill: #adb8be;\n      }\n\n      .cls-46 {\n        fill: #81a0b9;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-48 {\n        fill: #3aa956;\n      }\n\n      .cls-49 {\n        opacity: .49;\n      }\n\n      .cls-50 {\n        stroke: #e2e2e0;\n      }\n\n      .cls-50, .cls-51 {\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .cls-50, .cls-52 {\n        fill: #e2e2e0;\n      }\n\n      .cls-53, .cls-51 {\n        fill: none;\n      }\n\n      .cls-54 {\n        fill: #7d9bb1;\n      }\n\n      .cls-55 {\n        fill: #7693a8;\n      }\n\n      .cls-6 {\n        fill: #5aa3af;\n      }\n\n      .cls-56 {\n        fill: #083f64;\n        opacity: .2;\n      }\n\n      .cls-57 {\n        fill: #6d8798;\n      }\n\n      .cls-58 {\n        fill: #7d9cb2;\n      }\n\n      .cls-59 {\n        fill: #d7b2a3;\n      }\n\n      .cls-60 {\n        fill: #e7443a;\n      }\n\n      .cls-51 {\n        opacity: .3;\n        stroke: #000;\n      }\n\n      .cls-61 {\n        fill: #e8bfab;\n      }\n\n      .cls-11 {\n        opacity: .6;\n      }\n\n      .cls-62 {\n        fill: #6e889b;\n      }\n\n      .cls-63 {\n        fill: #748ea3;\n      }\n\n      .cls-64 {\n        fill: #517cbe;\n      }\n\n      .cls-7 {\n        opacity: .4;\n      }\n\n      .cls-65 {\n        fill: #7694a9;\n      }\n\n      .cls-66 {\n        fill: #7490a5;\n      }\n\n      .cls-67 {\n        fill: #fab615;\n      }\n\n      .cls-68 {\n        fill: #7794a9;\n      }\n\n      .cls-69 {\n        fill: #809eb6;\n      }\n\n      .cls-70 {\n        fill: #5099a6;\n      }\n\n      .cls-35 {\n        fill: #1a2c3d;\n      }\n\n      .cls-71 {\n        fill: #81a1bb;\n      }\n\n      .cls-22 {\n        fill: #addcea;\n      }\n\n      .cls-72 {\n        fill: #6f889c;\n      }\n\n      .cls-73 {\n        fill: #02272f;\n      }\n\n      .cls-74 {\n        fill: #2f393e;\n      }\n\n      .cls-75 {\n        fill: #010101;\n      }\n\n      .cls-76 {\n        fill: #7e9bb2;\n      }\n\n      .cls-77 {\n        fill: #0b3653;\n      }\n\n      .cls-78 {\n        fill: #387f8b;\n      }\n\n      .cls-79 {\n        fill: #5380c1;\n      }\n\n      .cls-80 {\n        fill: #7a97ac;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "359.46 287.22 307.71 287.22 321.39 185.33 345.78 185.33 359.46 287.22"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m308.57,332.17c-57.52,22.18-207.9,47.65-256.04-39.39C-22.25,157.54,89.16,23.04,169.26,42.65c57.51,14.08,92.39,32.32,144.48-3.36,58.93-40.37,236.34-56.88,305.17,16.71,60.64,64.83-4.26,118.12,21.83,168.62,95.81,185.46-171.25,111.12-223.28,92.38-52.02-18.74-80.94,4.4-108.88,15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m334.9,336.79c-92.39-1.95-354.73,53.6-333.71-141.48C22.22.23,222.82,137.25,313.73,71.98c90.91-65.28,184.7-114.18,277.68-17.81,92.98,96.37,95.11,108.62,54.98,176.92-40.13,68.3-41.23,138.31-168.98,123.44-127.75-14.87-106.55-16.99-142.51-17.74Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "359.46 287.22 307.71 287.22 321.39 185.33 345.78 185.33 359.46 287.22"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 285.5,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 283.77,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 282.04,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 280.32,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 278.59,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 276.86,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 275.14,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 273.41,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 271.68,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 269.95,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 268.23,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 266.5,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 264.77,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 263.05,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 261.32,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 259.59,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 257.87,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 256.14,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 254.41,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 252.69,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 250.96,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 249.23,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 247.5,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 307.71,
    y: 245.78,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 307.71,
    y: 244.05,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 307.71,
    y: 242.32,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 307.71,
    y: 240.6,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 307.71,
    y: 238.87,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 307.71,
    y: 237.14,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 307.71,
    y: 235.42,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 307.71,
    y: 233.69,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 307.71,
    y: 231.96,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 307.71,
    y: 230.23,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 307.71,
    y: 228.51,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 307.71,
    y: 226.78,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 307.71,
    y: 225.05,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 307.71,
    y: 223.33,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 307.71,
    y: 221.6,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 307.71,
    y: 219.87,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 307.71,
    y: 218.15,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 307.71,
    y: 216.42,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 307.71,
    y: 214.69,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 307.71,
    y: 212.96,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 307.71,
    y: 211.24,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 307.71,
    y: 209.51,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 307.71,
    y: 207.78,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 307.71,
    y: 206.06,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 307.71,
    y: 204.33,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 307.71,
    y: 202.6,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 307.71,
    y: 200.88,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 307.71,
    y: 199.15,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 307.71,
    y: 197.42,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 307.71,
    y: 195.7,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 307.71,
    y: 193.97,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 307.71,
    y: 192.24,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 307.71,
    y: 190.51,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 307.71,
    y: 188.79,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 307.71,
    y: 187.06,
    width: 51.75,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 307.71,
    y: 185.33,
    width: 51.75,
    height: 1.73
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m184.1,43.5h298.99c6.08,0,11.02,4.94,11.02,11.02v181.91c0,6.08-4.94,11.02-11.02,11.02H184.1c-6.08,0-11.02-4.94-11.02-11.02V54.52c0-6.08,4.94-11.02,11.02-11.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m482.95,240.74H183.97c-2.49,0-4.5-1.92-4.5-4.3V62.93c0-2.37,2.02-4.3,4.5-4.3h298.99c2.49,0,4.5,1.92,4.5,4.3v173.51c0,2.37-2.02,4.3-4.5,4.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 179.36,
    y: 50.55,
    width: 308.15,
    height: 12.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 185.51,
    y: 54.02,
    width: 31.91,
    height: 4.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 460.72,
    y: 54.28,
    width: 5.15,
    height: 4.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 467.85,
    y: 54.28,
    width: 5.15,
    height: 4.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 474.97,
    y: 54.28,
    width: 5.15,
    height: 4.04
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 257.06,
    y: 283.61,
    width: 153.06,
    height: 7.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m311.69,297.88c-57.51-.1-163.5,1.81-150.42-7.84,13.09-9.65,82.12-.2,138.72-3.43,56.59-3.23,107.82-6.94,165.7-2.17,57.88,4.77,42.14,10.26,16.74,11.81-46.69,2.85-54.96,4.08-82.03,2.52-79.22-4.58-66.32-.84-88.71-.88Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 179.36,
    y: 62.77,
    width: 308.21,
    height: 24.72
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 310.67,
    y: 70.2,
    width: 150.05,
    height: 12.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 430.81,
    y: 70.2,
    width: 29.92,
    height: 12.24
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 190.42,
    y: 66.26,
    width: 8.83,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 202.88,
    y: 70.93,
    width: 6.23,
    height: 7.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 213.27,
    y: 70.93,
    width: 6.23,
    height: 7.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 239.24,
    y: 70.93,
    width: 5.19,
    height: 7.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 223.66,
    y: 70.93,
    width: 6.23,
    height: 12.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 233,
    y: 65.74,
    width: 3.12,
    height: 12.98
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m450.05,80.09l-2.5-2.5c.48-.6.78-1.36.78-2.18,0-1.92-1.56-3.48-3.48-3.48s-3.48,1.56-3.48,3.48,1.56,3.48,3.48,3.48c.83,0,1.59-.29,2.18-.78l2.5,2.5c.07.07.17.11.26.11s.19-.04.26-.11c.14-.14.14-.37,0-.52Zm-5.2-1.94c-1.51,0-2.74-1.23-2.74-2.74s1.23-2.74,2.74-2.74,2.74,1.23,2.74,2.74-1.23,2.74-2.74,2.74Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 141.15,
    cy: 325.52,
    rx: 37.02,
    ry: 1.72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "138.29 143.58 145.38 143.18 146.98 164.73 139.89 165.13 138.29 143.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m150.68,137.76c.15,5.06-3.22,9.26-7.54,9.39-4.31.13-7.93-3.87-8.09-8.93-.01-.43-.26-3.98-.43-6.86-.12-2.04,1.47-3.77,3.51-3.83l9.1-.27c2.1-.06,3.81,1.66,3.73,3.76-.12,2.86-.29,6.31-.28,6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m148.77,140.03s-3.73,2.05-6.97.51c0,0,4.11,5.62,6.97-.51Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m156.68,185.2c.17-4.88,2.94-11.66,3.06-17.72.1-5.23-.16-14.27-3.93-16.09-1.9-.91-7.17-1.32-7.17-1.32l-2.9-.38s.05,2.57-.13,3.46c-.34,1.71-.42,10.73-1.45,10.73-1.18,0-4.26-9.13-4.91-10.86-.34-.89-.62-3.38-.62-3.38,0,0-2.36.37-3.79.54-3.43.39-6.37.82-8.02,1.48-5.07,2.05-4.37,4.96-4.1,9.3,0,0,1.27,9.24,1.81,12.99.63,4.42.56,11.53.51,16.07-.05,4.42-.18,10.77-.18,10.77l-.79,4.86,1.09,2.36.12,7.25h32.65s.17-7.56.17-7.56l.78-.57-1.13-4.27s-1.22-13.66-1.08-17.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "150.48 305 149.78 316.78 153.69 321.99 157.94 323.18 157.94 324.44 153.94 324.53 147.54 322.69 144.58 321.56 143.49 319.51 144.14 317.46 144.49 315.8 144.69 305 150.48 305"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "159.28 324.97 159.62 324.53 159.11 322.97 153.7 321.8 144.14 316.89 143.95 317.44 143.2 319.56 144.14 321.22 144.59 322.31 145.07 324.97 146 324.97 146.35 322.65 153.59 324.97 159.28 324.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "127.14 305.91 124.83 316.78 128.74 321.99 132.99 323.18 132.99 324.44 128.99 324.53 122.59 322.69 119.63 321.56 118.54 319.51 119.19 317.46 119.54 315.8 121.5 305 127.14 305.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "134.33 324.97 134.67 324.53 134.16 322.97 128.75 321.8 119.19 316.89 119 317.44 118.25 319.56 119.19 321.22 119.64 322.31 120.12 324.97 121.05 324.97 121.4 322.65 128.64 324.97 134.33 324.97"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "124.89 210.95 124.79 208.48 158.44 208.48 158.31 211.51 158.47 223.31 155.67 266.94 151.73 308.46 143.3 308.15 144.08 265.27 141.54 223.91 140.76 223.1 138.64 265.45 127.99 309.02 119.86 307.7 127.61 264.64 123.12 218.66 124.89 210.95"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m128.02,143.18c2.41-2.03-2.64-8-.37-9.51,8.37-5.58,5.47-10.15,14.21-11.9,2.76-.55,4.33.15,5.68,1.22.93.73,1.13,1.94,1.13,1.94,0,0,1.75,1.13,3.35,2.71,1.88,1.86-.83,7.9,2.62,11.77,2.28,2.56,1.13,6.59-.97,8.08-2.67,1.9.06,3.33-.82,3.2-3.46-.52-4.35-.39-5.67-.85-.38-.13-1.44-.17-1.44-.17l-.17-3.05c1.51-.66,3.21-1.96,4.23-4.37.24-.56.42-1.06.52-1.58.09-.47.19-.88.24-1.29.1-.76.16-2.45.09-3.51-.13-1.76-.54-4.03-1.44-5.75-1.11-2.12-2.58-2.51-2.58-2.51,0,0-.91-1.12-2.12,2.06s-4.75,3.83-5.94,4.62c-1.19.78,1.5,5.1.3,7.32-1.86,3.44,1.8,2.77-.25,8.02-.47,1.2-3.74.55-4.77.63-2.04.16-5.28,1.33-7.33,1.23-3.16-.16-4.72-3.08,1.49-8.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "120.55 197.91 122.85 201.25 124.5 201.47 126.23 203.18 128.52 203.92 132.59 204.91 132.37 205.57 131.02 207.62 128.33 209.87 125.36 208.96 122.86 207.66 120.69 204.91 116.56 200.11 120.55 197.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m114.82,184.26l7.71,15.26-5.12,3.16s-10.49-13.7-10.25-18.82c.43-9.18,9.55-22.37,15.28-29.1.88-1.04,1.68-2.65,4.38-1.97,2.38.6,3.76,2.89,2.64,6.01-3.21,8.92-14.64,25.47-14.64,25.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "194.55 139.61 192.92 140.21 187.81 151.19 182.95 147.87 190.01 136.5 191.55 135.07 193.81 133.23 195.84 132.14 196.03 132.22 195.79 133.28 194.81 133.96 194.15 134.91 194.55 134.89 194.55 139.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m151.77,160.8c-2.76-1.11-3.77-5.2-3.69-6.66.09-1.53.29-4.21,3.94-3.62,1.19.19,5.59.71,10.67,1.54,6.08,1,14.96,2.03,15.83,1.69.63-.63,3.68-4.82,6.85-10.9l4.88,4.12c-.17.56-1.72,5.13-4.58,10.63-.74,1.42-1.45,2.5-2.08,2.98-3.59,2.75-10.85,3.27-16.98,2.53,0,0-9.66-.22-14.83-2.29Z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 223.66,
    y: 106.47,
    width: 126.26,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 223.66,
    y: 113.45,
    width: 83.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 120.43,
    width: 115.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 126.13,
    width: 106.19,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 223.66,
    y: 142.94,
    width: 126.26,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 223.66,
    y: 149.92,
    width: 83.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 156.89,
    width: 115.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 162.59,
    width: 106.19,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 223.66,
    y: 179.4,
    width: 126.26,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 223.66,
    y: 186.38,
    width: 83.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 193.36,
    width: 115.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 199.06,
    width: 106.19,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 223.66,
    y: 215.86,
    width: 126.26,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 223.66,
    y: 222.84,
    width: 83.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 229.82,
    width: 115.06,
    height: 3.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 223.66,
    y: 235.52,
    width: 106.19,
    height: 3.15
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 372.83,
    y: 104.56,
    width: 28.74,
    height: 34.93,
    rx: 1.87,
    ry: 1.87
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 372.83,
    y: 144.38,
    width: 17.36,
    height: 21.1,
    rx: 1.87,
    ry: 1.87
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 372.83,
    y: 169.16,
    width: 17.36,
    height: 21.1,
    rx: 1.87,
    ry: 1.87
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 404.56,
    y: 104.56,
    width: 28.74,
    height: 34.93,
    rx: 1.87,
    ry: 1.87
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 393.71,
    y: 143.36,
    width: 39.59,
    height: 48.11,
    rx: 1.87,
    ry: 1.87
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-51",
    x1: 190.42,
    y1: 99.85,
    x2: 477.54,
    y2: 99.85
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m253.54,90.89c-.17-.17-.37-.25-.6-.25h-8.48c-.23,0-.43.08-.6.25-.17.17-.25.37-.25.6v6.45c0,.23.08.43.25.6.17.17.37.25.6.25h8.48c.23,0,.43-.08.6-.25.17-.17.25-.37.25-.6v-6.45c0-.23-.08-.43-.25-.6Zm-.43,7.04s-.02.09-.05.12c-.03.03-.07.05-.12.05h-8.48s-.09-.02-.12-.05c-.03-.03-.05-.07-.05-.12v-6.45s.02-.09.05-.12c.03-.03.07-.05.12-.05h8.48s.09.02.12.05c.03.03.05.07.05.12v6.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m245.98,94.03c.28,0,.52-.1.72-.3.2-.2.3-.44.3-.72s-.1-.52-.3-.72c-.2-.2-.44-.3-.72-.3s-.52.1-.72.3c-.2.2-.3.44-.3.72s.1.52.3.72c.2.2.44.3.72.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "247.51 95.56 246.66 94.71 244.96 96.4 244.96 97.42 252.43 97.42 252.43 95.05 250.22 92.84 247.51 95.56"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m281.57,90.55c-1.52,0-2.76,1.24-2.76,2.76,0,.51.14,1.01.41,1.45l2.19,3.52c.04.07.12.11.2.11h0c.08,0,.15-.04.2-.11l2.13-3.56c.25-.43.39-.91.39-1.41,0-1.52-1.24-2.76-2.76-2.76Zm1.97,3.93l-1.94,3.24-1.99-3.2c-.22-.36-.35-.78-.35-1.21,0-1.27,1.03-2.3,2.3-2.3s2.3,1.03,2.3,2.3c0,.42-.11.82-.33,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m281.57,91.93c-.76,0-1.38.62-1.38,1.38s.61,1.38,1.38,1.38,1.38-.63,1.38-1.38-.62-1.38-1.38-1.38Zm0,2.3c-.51,0-.92-.41-.92-.92s.42-.92.92-.92.92.42.92.92-.4.92-.92.92Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m265.7,98.53h0c-.24,0-.47-.09-.64-.26l-2.4-2.4c-.35-.35-.35-.92,0-1.28l3.23-3.24c.33-.33.78-.52,1.25-.52h2.05c.5,0,.9.4.9.9v2.05c0,.47-.18.91-.52,1.25l-3.24,3.24c-.17.17-.4.26-.64.26Zm1.44-7.1c-.31,0-.6.12-.82.34l-3.23,3.24c-.12.12-.12.31,0,.43l2.4,2.4c.06.06.13.09.21.09h0c.08,0,.16-.03.21-.09l3.24-3.24c.22-.22.34-.51.34-.82v-2.05c0-.17-.13-.3-.3-.3h-2.05Zm.77,2.45c-.5,0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9Zm0-1.2c-.17,0-.3.13-.3.3s.13.3.3.3.3-.13.3-.3-.13-.3-.3-.3Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_44.Google_Search"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m230.09,91.45c1.22,0,2.21.99,2.21,2.22v-.09h1.11c-.05-1.76-1.47-3.18-3.23-3.23v1.11h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m235.02,97.81l-.78.78-2.65-2.65.78-.78,2.65,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m233.42,93.57h-1.11v.09c0,1.22-.99,2.21-2.21,2.21h.09v1.11c1.76-.05,3.18-1.47,3.23-3.23,0-.03,0-.06,0-.09h0v-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m230.09,95.88c-1.22,0-2.21-.99-2.21-2.21v.09h-.09s-1.02,0-1.02,0c.05,1.76,1.47,3.18,3.23,3.23.03,0,.06,0,.09,0h.09v-1.11h-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m227.88,93.76v-.09h0c0-1.22.99-2.21,2.21-2.22h.09v-1.11h0s-.09,0-.09,0c-.03,0-.06,0-.09,0-1.76.05-3.18,1.47-3.23,3.23,0,.03,0,.06,0,.09v.09h1.11Z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m299.63,90.69h-7.41c-.16,0-.29.13-.29.29v7.41c0,.16.13.29.29.29h7.41c.16,0,.29-.13.29-.29v-7.41c0-.16-.13-.29-.29-.29Zm-.29,7.41h-6.84v-6.84h6.84v6.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m295.92,92.11h-2.62c-.16,0-.29.13-.29.29v2.14c0,.16.13.29.29.29h2.62c.16,0,.29-.13.29-.29v-2.14c0-.16-.13-.29-.29-.29Zm-.29,2.14h-2.04v-1.57h2.04v1.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m298.34,92.11h-1.33c-.16,0-.29.13-.29.29s.13.29.29.29h1.33c.16,0,.29-.13.29-.29s-.13-.29-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m298.34,93.25h-1.33c-.16,0-.29.13-.29.29s.13.29.29.29h1.33c.16,0,.29-.13.29-.29s-.13-.29-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m298.34,94.39h-1.33c-.16,0-.29.13-.29.29s.13.29.29.29h1.33c.16,0,.29-.13.29-.29s-.13-.29-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m298.34,95.53h-5.04c-.16,0-.29.13-.29.29s.13.29.29.29h5.04c.16,0,.29-.13.29-.29,0-.16-.13-.29-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m298.34,96.67h-5.04c-.16,0-.29.13-.29.29s.13.29.29.29h5.04c.16,0,.29-.13.29-.29,0-.16-.13-.29-.29-.29Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m308.33,93.9c.37,0,.67-.3.67-.67s-.3-.67-.67-.67-.67.3-.67.67.3.67.67.67Zm0,.67c-.37,0-.67.3-.67.67s.3.67.67.67.67-.3.67-.67-.3-.67-.67-.67Zm0,2c-.37,0-.67.3-.67.67s.3.67.67.67.67-.3.67-.67-.3-.67-.67-.67Z"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 538.89,
    cy: 339.98,
    rx: 52.63,
    ry: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m575.56,223.05l-.71,3.36c-1.38.72-3.44.39-3.44.39-1.51-.23-2.01-.81-2.08-.9l.28-1.79-.28.26h0s-.47.58-.47.58h0s-.04.09-.04.09l-.18.37c-.25.79-.52,1.16-.84,1.15-.15,0-.25-.08-.31-.17,0,0-.01,0-.02-.02,0,0,0,0,0,0,0,0,0,0,0,0-.06-.1-.08-.23-.07-.35.04-.31.26-1.24.26-1.24,0,0,0,0,0,0,0,0,0,0,0,0l.86-1.95,2.02-3.05-.9-8.67,4.87-.27.56,7.18.48,5.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m571.75,231.22v.13c-.04.27.15.51.42.54.27.03.51-.17.54-.44l.02-.18.69-4.89h-1.17s-.5,4.83-.5,4.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m573.42,230.1c-.02.27.17.51.44.53.27.02.51-.17.53-.44l.03-.3.47-3.73-1.26.23-.19,3.48-.02.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m570.04,231.81c-.04.27.14.52.41.56.27.04.52-.15.56-.41v-.04s1.01-5.55,1.01-5.55l-1.24-.16-.72,5.54v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m568.47,230.64l-.06.33c-.05.27.12.52.39.58.27.05.52-.12.58-.39l.03-.16,1.12-4.87-1.16-.4-.89,4.91h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "569.62 224.11 571.09 223.43 572.09 221.73 571.14 223.61 569.55 224.37 569.62 224.11"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "569.87 216.55 575.2 215.75 575.38 217.79 570.1 218.45 569.87 216.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m550.14,167.15c.45,2.02,1.63,4.72,1.63,4.72l14.07,21.13,3.74,24.81,5.98-.9-.92-24.5-.97-3.1s-10.61-21.36-15.05-26.86c-.82-1.02-3.1-2.13-4.78-1.41-2.16.94-4.52,2.45-3.7,6.12Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m560.64,176.4l-1.07,7.18.55.83s.6-6.03.52-8.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m580.05,240.52l-120.18-46.62,5.43-14.05,120.18,46.62c.23.09.35.35.26.59l-5.1,13.2c-.09.24-.36.35-.59.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m575.27,242.21l-88.31-34.3c-2.22-.86-3.33-3.36-2.47-5.58l4.7-12.17c.86-2.22,3.36-3.33,5.58-2.47l88.31,34.3c2.22.86,3.33,3.36,2.47,5.58l-4.7,12.17c-.86,2.22-3.36,3.33-5.58,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m582.87,227.84c.82-2.12-.23-4.49-2.35-5.31l-84.89-32.96c-2.12-.82-4.49.23-5.31,2.35l-.41,1.06,92.55,35.93.41-1.07Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m396.27,117.36c-1.35.47-2.7,1-4.03,1.59-26.45,11.7-38.45,42.75-26.74,69.19,11.71,26.45,42.76,38.43,69.19,26.74,26.45-11.7,38.45-42.74,26.74-69.19-11.11-25.12-39.67-37.2-65.17-28.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m392.44,106.31c-1.66.58-3.3,1.22-4.92,1.94-32.35,14.31-47.02,52.27-32.7,84.62,14.31,32.35,52.29,47,84.62,32.7,32.34-14.31,47.02-52.27,32.7-84.61-13.59-30.72-48.51-45.49-79.69-34.65Zm42.26,108.57c-26.44,11.69-57.49-.29-69.19-26.74-11.7-26.45.29-57.49,26.74-69.19,1.33-.59,2.67-1.12,4.03-1.59,25.5-8.87,54.05,3.21,65.17,28.33,11.7,26.45-.29,57.49-26.74,69.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m396.27,117.36c-1.35.47-2.7,1-4.03,1.59-26.45,11.7-38.45,42.75-26.74,69.19,11.71,26.45,42.76,38.43,69.19,26.74,26.45-11.7,38.45-42.74,26.74-69.19-11.11-25.12-39.67-37.2-65.17-28.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m395.16,114.27c-29.07,10.11-44.44,41.88-34.33,70.95,10.11,29.07,41.88,44.44,70.95,34.33,29.07-10.11,44.44-41.88,34.33-70.95-10.11-29.07-41.88-44.44-70.95-34.33Zm39.54,100.61c-26.44,11.69-57.49-.29-69.19-26.74-11.7-26.45.29-57.49,26.74-69.19,1.33-.59,2.67-1.12,4.03-1.59,25.5-8.87,54.05,3.21,65.17,28.33,11.7,26.45-.29,57.49-26.74,69.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m395.16,114.27c-29.07,10.11-44.44,41.88-34.33,70.95,10.11,29.07,41.88,44.44,70.95,34.33,29.07-10.11,44.44-41.88,34.33-70.95-10.11-29.07-41.88-44.44-70.95-34.33Zm39.54,100.61c-26.44,11.69-57.49-.29-69.19-26.74-11.7-26.45.29-57.49,26.74-69.19,1.33-.59,2.67-1.12,4.03-1.59,25.5-8.87,54.05,3.21,65.17,28.33,11.7,26.45-.29,57.49-26.74,69.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m462.88,149.72c9.49,27.29-4.93,57.11-32.22,66.61-27.29,9.49-57.11-4.93-66.61-32.22-9.49-27.29,4.93-57.11,32.22-66.61,27.29-9.49,57.11,4.93,66.61,32.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m457.63,151.55c8.48,24.39-4.41,51.04-28.8,59.52-24.39,8.48-51.04-4.41-59.52-28.8-8.48-24.39,4.41-51.04,28.8-59.52,24.39-8.48,51.04,4.41,59.52,28.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m415.23,143.17c16.74-1.24,32.11,2.47,42.92,9.35-.11-.35-.21-.69-.33-1.04-8.52-24.5-35.29-37.45-59.79-28.92-19.58,6.81-31.77,25.27-31.53,44.92,8.18-12.86,26.64-22.67,48.72-24.31Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 537.05,
    y: 152.57,
    width: 12.13,
    height: 7.58,
    transform: "translate(346.75 686.32) rotate(-85.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m535.7,143.62c-1.03,4.53-.21,8.21,5.75,8.96,3.93.49,7.19-1.24,8.23-5.77.15-.64,2.37-8.8,2.39-9.43l-2.42-3.11-5.39-2.88-4.91.26c-.07.16-2.08,1.31-2.63,4.2-.51,2.68-.92,7.3-1.03,7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m540.26,145.59l.65-3.1.25-1.81-.79-.38-1.5,1.5-.8-.49c.19-.59-.06-1.93.28-3.19.05-.21-.43-.62-.38-.82.28-1.07.6-2.13.81-2.82-.7-.36-1.28-.93-1.77-2.27-.99-2.7.1-4.25,1.09-4.86.5-.31,2.03-.76,5.28.75,3.25,1.51,3.46-.18,5.42.92,3.09,1.73,5.54,6.43,5.04,10.01-.38,2.71-1.48,5.49-2.38,6.82l-1.79,3.21-1.54,1.26-5.66-.38"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m568.94,338.99h.2l.04.99h4.73l-.13-1.31h-.15s0-.02,0-.02l-1.72-4.58h-4.91l-.1.63-2.27,1.66-5.47,1.82s-.57.25-.55.56l.02.57v.34s.1.15.68.32h8.23l.5-.66.48-.3.42-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m519.19,339.79h.2l.04.99h4.73l-.13-1.31h-.15s0-.02,0-.02l-1.08-4.81h-4.91l-.1.63-1.2,1.66-7.18,2.05s-.57.25-.55.56l.02.57v.34s.1.15.69.32h8.23l.5-.66.48-.3.42-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "520.23 342.99 519.99 343 519.99 342.99 520.23 342.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "565.07 335.2 572.88 333.97 559.3 278.16 556.54 236.57 556.82 230.91 554.89 226.02 554.96 223.29 536.84 223.29 537.31 228.38 547.49 280.34 565.07 335.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "516.22 335.23 524.18 335.61 532.16 280.09 540.98 226.95 540.98 223.29 523.29 223.29 522.53 229.32 520.23 278.82 516.22 335.23"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m519.37,227.85s5.45-22.37,5.58-29.69c.09-5.16-.69-10-.71-16.77-.03-10.51,1.75-15.36,3.37-21.05,1.02-3.57,4.56-3.12,6.28-3.06,1.38.04,4.26.35,4.26.35l12.28.66c9.68,1.56,11.71,7.32,9.79,21.57l-3.42,19.07,1.54,29.49s-4.11,2.97-19.5,1.36c-5.37-.56-19.48-1.93-19.48-1.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "547.18 156.78 538.94 156.35 538.34 157.71 547.61 158.21 547.18 156.78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m492.43,206.29l2.94.22,4.41-4.11,3.89,3.35-6.99,5.51-2.85.76-4.25-.5c-1.63-.91-3.54-3.22-3.54-3.22v-.86s2.79,1.22,2.79,1.22l3.44-.27.43-.36-1.36-.71-1.3-.05-.44-.61.13-.28,2.69-.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "497.48 203.98 495.88 205.37 500.37 209.7 502.07 208.14 497.48 203.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m527.55,159.65c-1.26,1.65-2.57,4.28-2.57,4.28l-15.68,27.52-12.98,13.1,5.4,4.47,13.52-10.5,1.18-1.14s18.83-27.32,20.19-34.27c.25-1.28-.36-3.75-1.99-4.57-2.1-1.05-4.78-1.89-7.07,1.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m529.99,176.4l-5.65,9.05.11,1.95s5.16-9.6,5.54-11Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordsNoContent);
export default __webpack_public_path__ + "static/media/keywords_no_content.07972d900453148ffe240c3d38a8dad9.svg";
export { ForwardRef as ReactComponent };